import axios from '../axios';
import csrfToken from '../../shared/meta';

axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken();

export default function updateWireFeaturedContributors(wireId) {
  return axios.put(`/hotwired/wires/${wireId}/featured_contributors`, { responseType: 'text', cache: { ignoreCache: true } });
}
